import type { ApiFetchLastGamesPort } from '~/handlers/ports/api-fetch-last-games.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchLastGamesAdapter
  implements ApiFetchLastGamesPort
{
  async handle(userId: number) {
    try {
      const url = `${getApostatudoApiUrl()}/last-games?user_id=${userId}`;

      // Timeout de 5 segundos para não travar nada
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        return [];
      }

      const data = await response.json();

      // API retorna array direto de LastGame[]
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }
}
